import {
    deleteUserVehicle,
    postUserVehicle,
    putActivateUserVehicle,
} from "../../api/userVehicleController";

export const createUserVehicle = async ({
	vehicleYearId,
	makeId,
	modelId,
	yearId,
	variantId,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const response = await postUserVehicle({
			vehicleYearId,
			makeId,
			modelId,
			yearId,
			variantId
		});

		if (!!response?.success) {
			setStatusSuccess();
		} else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const removeUserVehicle = async ({
	userVehicleId,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const response = await deleteUserVehicle({
			userVehicleId
		});

		if (!!response?.success) {
			setStatusSuccess();
		} else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const activateUserVehicle = async ({
                                            userVehicleId,
                                            setStatusInProgress,
                                            setStatusSuccess,
                                            setStatusFailed,
                                            setStatusError
                                        }) => {
    setStatusInProgress();
    try {
        const response = await putActivateUserVehicle({
            userVehicleId
        });

        if (!!response?.success) {
            setStatusSuccess();
        } else {
            setStatusFailed();
        }
    }
    catch (error) {
        console.error(error);
        setStatusError();
    }
};